import { IconExpandLess } from 'cdk-radial';
import styled from 'styled-components';

export const StyledScrollToTopButton = styled(IconExpandLess)`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  fill: grey;
  background-color: white;
  width: 18px;
  border-radius: 50%;
  height: 17px;
  padding: 7px;
  margin: 0px 0px 0px 2px;
  cursor: pointer;
`;

export const StyledScrollToTopButtonOutside = styled.div`
  position: absolute;
  z-index: 3;
  margin: 7px 7px 9px 2px;
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),
    0 1px 18px 0 rgb(0 0 0 / 12%);
  border-radius: 50%;
`;
